import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class SuggestDataService {
  private http = inject(HttpClient);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  sendFeedback(data) {
    return this.http.post(`${environment.API_ROOT}feedback/`, data)
      .pipe(map((res: any) => res && res.body));
  }
}
